import classNames from 'classnames'
import { type StructuredText as StructuredTextType } from 'datocms-structured-text-utils'
import { graphql } from 'gatsby'
import React from 'react'

import Image from '@/components/image/image'
import Link from '@/components/link/link'
import StructuredTextDefault from '@/components/structured-text/structured-text-default'
import TextElement from '@/components/text-element/text-element'
import { generateUrl } from '@/internal/utils/generate-url'
import { resolvePctLinkUrl } from '@/internal/utils/resolve-pctlink-url'

import * as styles from './slice-navigation.module.scss'

export const SliceNavigation: React.FC<
  Queries.SectionSliceNavigationFragment
> = (props) => {
  const { title, subtitle, items } = props
  if (!title && !subtitle && items !== null && items.length === 0) {
    return <></>
  }
  return (
    <div className="container">
      <TextElement type="h1" text={title!} />
      <TextElement type="h2" text={subtitle!} />
      <div className="row mt-lg-2 mb-lg-5 justify-content-center">
        {items &&
          items.length > 0 &&
          items.map((item) => {
            if (!item) return null
            return (
              <div className="col-lg-4 col-md-6 mb-lg-4 mb-0" key={item.id}>
                <SliceNavigationItem {...item} />
              </div>
            )
          })}
      </div>
    </div>
  )
}
export default SliceNavigation

export const SliceNavigationItem: React.FC<
  Queries.SliceItemNavigationFragment
> = (props) => {
  const { icon, preTitle, title, content, link, colour } = props

  const sliceNavigationItem = (
    <div className="py-4 px-4 pb-5">
      {!!icon && (
        <div className={styles.iconBox}>
          <Image image={icon} />
        </div>
      )}
      <TextElement type="div" text={preTitle!} className={styles.preTitle} />
      <TextElement type="h4" text={title!} />
      {content && (
        <StructuredTextDefault content={content as StructuredTextType} />
      )}
      {!!link && (
        <div className={styles.ctaDistr}>
          <div className={styles.ctaIcon} />
        </div>
      )}
    </div>
  )
  const backgroundStyle = colour?.colour?.hex
    ? { backgroundColor: colour.colour.hex }
    : {}
  const textDark = colour?.isLight === true ? styles.textDark : ''

  const linkType = link?.__typename
  let url = ''
  if (linkType === 'DatoCmsPctLink') {
    url = resolvePctLinkUrl(link)
  } else {
    url = generateUrl(linkType, link?.slug)
  }
  return (
    <>
      {link ? (
        <Link
          to={url}
          className={classNames(styles.cardDistribuidora, textDark)}
          style={backgroundStyle}
        >
          {sliceNavigationItem}
        </Link>
      ) : (
        <div
          className={classNames(styles.cardDistribuidora, textDark)}
          style={backgroundStyle}
        >
          {sliceNavigationItem}
        </div>
      )}
    </>
  )
}

export const query = graphql`
  fragment SectionSliceNavigation on DatoCmsSliceNavigation {
    __typename
    id
    navigationLabel
    title
    subtitle
    items {
      ...SliceItemNavigation
    }
  }

  fragment SliceItemNavigation on DatoCmsSliceNavigationItem {
    __typename
    id
    preTitle
    title
    icon {
      url
      gatsbyImageData
    }
    colour {
      ... on DatoCmsPctColour {
        colour {
          hex
        }
        isLight
      }
    }
    content {
      value
    }
    link {
      __typename
      ... on DatoCmsPctPage {
        slug
      }
      ... on DatoCmsPctProject {
        slug
      }
      ... on DatoCmsPctPost {
        slug
      }
      ... on DatoCmsPctInternalPage {
        slug
      }
      ... on DatoCmsPctPaper {
        slug
      }
      ... on DatoCmsPctTopic {
        slug
      }
      ... on DatoCmsPctTag {
        slug
      }
      ... on DatoCmsPctDialog {
        slug
      }
      ... on DatoCmsPctLink {
        ...PctLink
      }
    }
  }
`
